import type { ArticleItem, FolderItem, ViewItem } from '@easterngraphics/wcf/modules/bsk';
import type { ArticleElement } from '@easterngraphics/wcf/modules/cf';
import type { ShareFormat } from '@egr/xbox/base-app/Share';
import type { TelemetryEventQueue } from '@egr/xbox/telemetry/TelemetryEventQueue';
import type { FileFormatInfo } from '@egr/xbox/utils/FileFormats';

export interface ShareOptions {
    items: ReadonlyArray<ArticleElement | ViewItem | ArticleItem | FolderItem>;
    itemIds: ReadonlyArray<string>;
    formats: ReadonlySet<string>;
    projectName: string;
    articleName?: string;
    /** used for owds uploads */
    purpose?: string;
    shareAsLink?: boolean;
    telemetryEventQueue?: TelemetryEventQueue;
    basketIdentifier?: string;
    errorHandler?: (value: Error, matchingFormats: Array<string>) => void;
}

export const enum ShareContentSource {
    REMOTE_URL,
    APP_API_PATH,
    LOCAL_CONTENT
}

export interface RemoteShareContent {
    source: ShareContentSource.APP_API_PATH | ShareContentSource.REMOTE_URL,
    content: string;
    filename: string;
    filetype: FileFormatInfo;
    shareFormatKey?: ShareFormat;
}

export type ShareContent = RemoteShareContent | {
    source: ShareContentSource.LOCAL_CONTENT,
    content: string | ArrayBuffer | Blob;
    filename: string;
    filetype: FileFormatInfo;
    shareFormatKey?: ShareFormat;
};
